RivalIQ.module('enums', function (enums, App, Backbone, Marionette, $, _) {

    'use strict';

    enums.graph = {
        position: {
            LEFT: 0x1,
            RIGHT: 0x2,
            MIDDLE: 0x4
        },
        elisions: {
            ABOVE: 0x1,
            BELOW: 0x2
        }
    };
});
